// eslint-disable-next-line import/extensions
import getApolloClient from './dist/apollo-client/client';

export default getApolloClient;
